import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useRefresh } from '../context/RefreshContext';

export function useJobs(startDate, endDate, { managerId } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { refreshCount } = useRefresh();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (managerId) params.manager_id = managerId;
    apiClient.get('/st/jobs', { params })
      .then(res => { if (!cancelled) setData(res.data.jobs || res.data || []); })
      .catch(err => { if (!cancelled) setError(err.response?.data?.error || 'Failed to load jobs'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshCount, startDate, endDate, managerId]);

  return { data, loading, error };
}
